import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Container, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm('service_e7fj1dr', 'template_ygws5n9', form.current, {
        publicKey: '7_psy8IUDH5wm0Awj',
      })
      .then(
        () => {
          setLoading(false);
          Swal.fire({
            title: 'Done!',
            text: 'Email Sent!',
            icon: 'success',
            confirmButtonColor: '#149DDD',
          });
          form.current.reset();
        },
        (error) => {
          setLoading(false);
          Swal.fire({
            title: 'Error!',
            text: 'Failed to send message. Please reach out to babu.balajijr@gmail.com',
            icon: 'error',
            confirmButtonColor: '#149DDD',
          });
          console.error('FAILED...', error.text);
        }
      );
  };

  return (
    <Container id="contact" className="form-div">
      <h2 className="header-clr">Contact</h2>
      <div className="divider"></div>
      <br />
      <p>
        Feel free to reach out for software engineering opportunities, technical discussions, or collaborations. Send a message below or email directly at <a href="mailto:babu.balajijr@gmail.com"><b>babu.balajijr@gmail.com</b></a>.
      </p>

      <Form id="contact-form" ref={form} onSubmit={sendEmail}>
        <Row className="mb-3">
          <Form.Group as={Col} md={6} controlId="formGridFName">
            <Form.Label>First Name</Form.Label>
            <Form.Control type="text" placeholder="First Name" name="user_name" required />
          </Form.Group>

          <Form.Group as={Col} md={6} controlId="formGridLName">
            <Form.Label>Last Name</Form.Label>
            <Form.Control type="text" placeholder="Last Name" name="user_Lname" required />
          </Form.Group>
        </Row>

        <Form.Group className="mb-3" controlId="formGridEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" placeholder="Enter email" name="user_email" required />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formGridPhoneno">
          <Form.Label>Phone Number</Form.Label>
          <Form.Control placeholder="Phone Number" name="user_ph_no" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formGridMessage">
          <Form.Label>Message</Form.Label>
          <textarea name="message" placeholder="Your Message..." required />
        </Form.Group>

        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
              Sending...
            </>
          ) : (
            'Submit'
          )}
        </Button>
      </Form>
    </Container>
  );
};

export default Contact;